<template >
  <div name="documents">
    <div class="flex justify-between mb-4">
      <h2 class="text-gray-500 uppercase">Lesson Order</h2>
    </div>

    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" class="w-full mx-auto" v-else>
        <div
          style="width: 100%; text-align: center"
          class="spin-holder mt-4"
          v-if="loading"
        >
          <i class="spinner fa fa-spinner fa-spin"></i>
          <p>Loading Lessons</p>
        </div>

        <div v-else>
          <div v-if="componentLoaded">
            <draggable
              v-model="lessons"
              :element="'tbody'"
              @end="onEnd"
            >
              <tr
                v-for="item in orderedLessons"
                :key="item.order"
                class="course list-complete-item odd:bg-gray-200 "
              >
                <td class="w-2/12 center pl-4">{{ item.order }}</td>
                <td class="w-10/12">{{ item.name }}</td>
                <td class="dragme w-2/12 p-3">
                  <i class="icon fas fa-bars"></i>
                </td>
              </tr>
            </draggable>

                      <div class="w-11/12 -mx-3 mb-6 mt-4">
            <button
            @click="updateOrder"
              type="submit"
              class="publish-button hover:opacity-75 w-full cursor-pointer">
              Updater Order
            </button>

            <savenotice
              :title="'Order'"
              ref="saveNotice"
              class="left pl-6"
            ></savenotice>
          </div>
          </div>
          <p class="m-5 mx-12" v-else>
            We could not find any data for your given selection.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
const savenotice = () => import("@/components/SaveNotice.vue");

import { SchoolService } from "@/services/school.service";

export default {
  name: "documents",
  props: {
    course: Object,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    orderedLessons() {
      return _.orderBy(this.lessons, ["order", "name"]);
    },
    componentLoaded() {
      return this.lessons.length > 0;
    },
    schoolName() {
      return this.currentUser.schoolName;
    },
    hasNoLesson() {
      return this.lesson === undefined;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,

      lessons: [],
    };
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      SchoolService.getAll("courses/" + this.course.id + "/lessons")
        .then((response) => this.buildLessonList(response.data.data))
        .catch((err) => {
          console.log("Lessons " + err);
          //this.addNew();
        });
    },
    buildLessonList(data) {
      this.lessons = data;
      this.loading = false;
    },
    onEnd(event) { 
      this.lessons.forEach((item, index) => { item.order = index; }); 
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;


      return !relatedElement || !relatedElement.fixed;
    },
    updateOrder() {
      this.lessons.forEach((item, index) => { 
       SchoolService.update("lessons", item.id, item)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err);
          });

      })
     
    },
    completion() {
      this.$refs.saveNotice.saved();
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.$refs.saveNotice.failed();
      console.log("Lesson Order crud error " + error);
    },
  },
  components: {
    draggable,
        savenotice,

  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>


